<!-- <button type="button" class="btn btn-fb" [disabled]="loading" (click)="socialAuth()">Facebook {{type}}</button> -->
<button type="button" class="btn btn-lg btn-fb w100" [disabled]="loading" (click)="socialAuth()"><span>{{type}} {{ 'GENERAL.with' | translate }}</span> Facebook</button>
